<template>
  <div :class="{ 'page-class': !$store.getters.tableConfig.card }">
    <div class="page-header">
      <el-page-header @back="goBack" content="详情页面"></el-page-header>
    </div>
    <avue-crud
      :data="tableData"
      :option="tbleOption"
      @refresh-change="getList"
      @row-save="handleSubmit"
      @row-update="rowUpdate"
      @row-del="rowDel"
      @on-load="onLoad"
      @search-change="searchChange"
      @search-reset="searchReset"
      :page.sync="page"
    >
    </avue-crud>
  </div>
</template>
<script>
import List from './list';

export default List;
</script>
